<template>
<div>
 <el-dialog  title="货物监控"  :visible.sync="dialog" width="1130px" :fullscreen="true"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
    <div class="cont">
        <div class="map">
          <el-amap
             ref="map"
            vid="vueMap"
            :zoom="12"
            class="amap-demo"
            :events="events"
            complete="complete"
            >
              <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position"
              :visible="true"  :vid="index"></el-amap-marker>
          </el-amap>
        </div>
        <div class="detali">
            <div class="top">捆包号：{{rowData.cargoBarcode}}</div>
            <div class="bottom">
              <el-timeline :reverse="reverse">
                <el-timeline-item
                  v-for="(item, index) in activities"
                  :key="index"
                   :color="index==activities.length-1?'#67C23A':''"
                  :timestamp="item.performTime">
                  [{{[ "已包装", "已入库", "已出库", "汽运中", "汽运完成", "已装船", "海运中", "已卸船"][item.goodStatus]}}]<span style="margin-left:8px">{{item.goodStatus==6?'':item.goodDesc}}</span>
                </el-timeline-item>
              </el-timeline>
            </div>
        </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { gmonitoringList } from '@/api/data-center-server'
import { dateTimeFormat } from '@/utils/util'
export default {
  name: 'quanLiuCheng',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    let that = this
    return {
      dialog: false,
      reverse: true,
      activities: [],
      markers: [],
      path: [],
      events: {
        complete () {
          gmonitoringList({ historyGoodId: that.rowData.id }).then(res => {
            that.activities = res.list
            that.activities.forEach((item, index) => {
              that.activities[index].performTime = dateTimeFormat('', '', item.performTime)
              if (item.longitude) {
                that.markers.push({
                  'position': [item.longitude, item.latitude]
                })
                that.path.push([item.longitude, item.latitude])
              }
            })
            that.$nextTick(() => {
              let overlaysList = that.$refs.map.$$getInstance().getAllOverlays('marker')
              that.$refs.map.$$getInstance().setFitView(overlaysList)
              var polyline4 = new AMap.Polyline({
                path: that.path, // 设置线覆盖物路径
                showDir: true,
                strokeColor: '#3366dd', // 线颜色
                strokeWeight: 5 // 线宽
              })
              that.$refs.map.$$getInstance().add(polyline4)
            })
          })
          this.dialog = true
        }
      }

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.dialog = true
  },
  methods: {
    handleClick () {

    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.cont{
   height: calc(100vh - 100px);
   width: 100%;
   display: flex;
   .map{
     height:calc(100vh - 50px);
     flex: 1;
   }
   .detali{
      width: 400px;
      height:calc(100vh - 50px);
      margin-left: 20px;
      .top{
        text-align: center;
        font-size: 20px;
        padding: 20px;
        border-bottom: 1px dashed #0c46a2;
      }
      .bottom{
        padding: 20px;
        padding-top: 40px;
      }
   }
}
</style>
